import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {ImageTranslation} from "../../translations/image.ts";

interface NewsModalProps {
    isOpen: boolean;
    onClose: () => void;
    srcPicture?: string;
}


const NewsSecondModal: React.FC<NewsModalProps> = ({
                                                 isOpen,
                                                 onClose,
                                                 srcPicture
                                             }) => {


    const { translations } = useLanguage();
    const { language } = useLanguage();
    const picture = ImageTranslation[language];


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                <div className="p-6 pt-0">
                    <div className="flex justify-between items-start sticky-btn ">
                        <h3 className="text-2xl font-light"></h3>
                        <button
                            onClick={onClose}
                            className="bg-gray-400/50 hover:bg-gray-500/50 transition-colors rounded-full p-2"
                        >
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="prose max-w-none">
                        <div className='text-center'>
                            <img
                                src={srcPicture}
                                className="w-full  m-auto  pb-3 h-full object-cover rounded-lg"
                            />
                            <div className="p-6 px-8">
                                <h6 className="text-left tex-xs font-medium text-[#373f4a]">{translations.newsLatterModaleTitle} </h6>
                                <p className="text-left tex-xs text-[#373f4a] mt-4 leading-[1.3]">
                                    {translations.newsLatterText}
                                    {translations.newsLatterModaleText1} <span className="font-bold">{translations.newsLatterModaleText2}</span>
                                    {translations.newsLatterModaleText3}
                                    <span className="font-bold">{translations.newsLatterModaleText4}</span>
                                    {translations.newsLatterModaleText5} <span className="font-bold">{translations.newsLatterModaleText6}</span>
                                    {translations.newsLatterModaleText7}
                                </p>

                            </div>

                            <a
                                href={'https://agv-bs.de/erstes-ki-netzwerktreffen-des-jahres-bei-novobit/.'}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-click-primary m-3 mb-5 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700"
                            >
                                {translations.newsLetterAVGArticle}
                            </a>

                            <img
                                src={picture.newsLetterSecondPart_2}
                                className=" pb-3 h-fullw-full m-auto object-cover rounded-lg"
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsSecondModal;
